import React from 'react';
import { CustomSelect, CustomSelectProps } from 'web-library';
import { Control, Controller } from 'react-hook-form';

interface ControlledCustomSelectProps extends CustomSelectProps {
  name: string;
  control: Control<any>;
}

const ControlledCustomSelect = ({
  name,
  control,
  className = undefined,
  disabled = undefined,
  defaultValue = undefined,
  displayEmpty = false,
  fullWidth = undefined,
  label = undefined,
  labelId = undefined,
  menuItems,
  variant = undefined,
  ...otherProps
}: ControlledCustomSelectProps) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <CustomSelect
        className={className}
        disabled={disabled}
        displayEmpty={displayEmpty}
        fullWidth={fullWidth}
        label={label}
        labelId={labelId}
        menuItems={menuItems}
        onChange={(e) => field.onChange(e.target.value)}
        value={field.value}
        variant={variant}
        {...otherProps}
      />
    )}
  />
);

export default ControlledCustomSelect;
